<div class="container">
    <router-outlet></router-outlet>
</div>

<app-footer *ngIf="currentClient && currentClient.demandeur && currentClient.demandeur.responsableDossier"
            [user]="currentClient.demandeur.responsableDossier"></app-footer>
